import { faSquareList } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { AppRole } from "../../../@api";

import { FeatureCard } from "../../components/Pages/Landing/FeatureCard/FeatureCard";
import { guardWithProps } from "../../components/Routes/Functions/GuardWithProps";
import { lazyRoute } from "../../components/Routes/Functions/LazyRoute";
import { FeatureGuard } from "../../components/Routes/Guards/FeatureGuard";
import { translationKeys } from "../../models/app-translation-keys";
import { RouteConstants } from "../../models/enums";
import { Features } from "../feature.enum";
import { IFeature } from "../iFeature";

export const summaryFeature: IFeature = {
  id: Features.Summary,
  route: {
    path: RouteConstants.Summary,
    lazy: lazyRoute({
      importer: () => import("./SummaryPage"),
      componentName: "SummaryPage",
      guards: [guardWithProps(FeatureGuard, { role: AppRole.SummarizationFeature })],
    }),
  },
  menuItem: {
    label: translationKeys.feature.summary.link,
    breadCrumbTitle: translationKeys.feature.summary.breadCrumbTitle,
    url: `/${[RouteConstants.Ai, RouteConstants.Summary].join("/")}`,
    path: RouteConstants.Summary,
    showFooter: true,
    icon: () => <FontAwesomeIcon icon={faSquareList} />,
  },
  card: (
    <FeatureCard
      featureKey={Features.Summary}
      requiresBudget={true}
      featureIcon={faSquareList}
      route={RouteConstants.Ai}
      featureRoute={RouteConstants.Summary}
    />
  ),
  role: AppRole.SummarizationFeature,
};
